// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"Success_fieldWrapper__3Ds39","imgdiv":"Success_imgdiv__2Xi0G","row1":"Success_row1__1fiCl","row2":"Success_row2__29Ebp"};